import React, { useEffect } from 'react';
import { observer } from 'src/utils/mobx-react';
import { useCommon } from 'src/AppState/Common';
import { LoadingV2 } from 'src/components/Loading/LoadingV2';
import { Button } from 'src/domains/common/components/button/button';
import { MohPopupTriggersSection } from './MohPopupTriggers';
import { MohPopupTriggersTabState } from './MohPopupTriggersTab.state';
import { ErrorMessage, Header, MohPopupTriggersTabContainer, PageHeader } from './MohPopupTriggersTab.style';

export const MohPopupTriggersTab = observer('MohPopupTriggersTab', (): React.ReactElement => {
    const common = useCommon();
    const state = MohPopupTriggersTabState.get(common);
    const isFinished = !state.isLoading && !state.hasError;

    useEffect(() => {
        state.refresh().catch((error) => {
            console.error('MohPopupTriggersTab initial refresh error', error);
        });
    }, [state]);

    if (state.isLoading) {
        return (
            <LoadingV2
                dataTest='moh-popup-triggers-tab-loading'
                title='Loading...'
            />
        );
    }

    return (
        <MohPopupTriggersTabContainer data-test='moh-popup-triggers'>
            <PageHeader>
                <Header data-test='main-header'>MoH Pop-up Triggers</Header>
                <Button
                    variant='link'
                    size='sm'
                    dataTest='refresh-button'
                    onClick={(): void => {
                        state.refresh().catch((error) => {
                            console.error('MohPopupTriggersTab refresh error', error);
                        });
                    }}
                >
                    Refresh
                </Button>
            </PageHeader>

            {state.hasError ? <ErrorMessage>Error during fetching data</ErrorMessage> : null}

            <MohPopupTriggersSection
                type='your'
                header='Assigned To You'
                dataTest='moh-popup-triggers-assigned-to-you'
                notifications={state.yourNotifications}
                state={state}
                isFinished={isFinished}
            />
            <MohPopupTriggersSection
                type='none'
                header='Pending Requests'
                dataTest='moh-popup-triggers-pending-requests'
                notifications={state.noneNotifications}
                state={state}
                isFinished={isFinished}
            />
            <MohPopupTriggersSection
                type='other'
                header='Assigned To Others'
                dataTest='moh-popup-triggers-assigned-to-others'
                notifications={state.otherNotifications}
                state={state}
                isFinished={isFinished}
            />
        </MohPopupTriggersTabContainer>
    );
});
